<template>
  <div class="uk-flex-center uk-flex">
    <div class="container" v-if="!loggedIn">
      <div class="login-text text">
        <p>
          {{$t('moderatorAccess.welcome')}}
        </p>
      </div>
      <div style="z-index: -3" class="uk-flex-center uk-flex">
        <smart-button style="z-index: 2" :cssObject="buttonStyle" @onClick="signIn()" type="primary">{{$t('general.signIn')}}
        </smart-button>
      </div>
    </div>
    <div class="container" v-if="!hasAccess && loggedIn">
      <div class="access-text text">
        <div class="new-line">{{$t('moderatorAccess.accessPermissions')}}</div>
        <div class="new-line">{{$t('moderatorAccess.contactManager')}}</div>
      </div>
      <div style="z-index: -3" class="uk-flex-center uk-flex">
        <smart-button style="z-index: 2" :cssObject="buttonStyle" @onClick="signOut()" type="secondary">{{$t('general.signOut')}}
        </smart-button>
      </div>
    </div>
  </div>
</template>
<script>
  import SmartButton from '../../ui-components/buttons/smart-button'

  export default {
    name: 'moderator-access',
    components: {
      SmartButton
    },
    props: ['hasAccess', 'loggedIn'],
    data() {
      return {
        buttonStyle: {
          width: '254px',
          height: '44px'
        }
      }
    },
    methods: {
      signIn() {
        let state = {
          from: this.$route.path,
          download: false
        }
        this.$auth.id.signIn(state)
      },
      signOut() {
        this.$auth.id.signOut()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../src/styles/breakpoints';
  @import '../../../../src/styles/colours';

  .new-line {
    display: block;
    font-size: 44px;
    text-align: center;
    margin: 0;
    color: $text;
  }

  .text {
    margin-bottom: 47px;
  }

  .container {
    margin-top: 10%;
  }

  p {
    font-size: 44px;
    text-align: center;
    margin: 0;
    color: $text;
  }

  .login-text {
    width: 688px;
  }

  .access-text {
    width: 869px;
  }
</style>
